import type { ImportSitemapData } from '@/types'

// Written by the generator page before it navigates here. Same key the visual
// handoff reads, so the generator hands both project types over the same way.
export const CRAWLER_HANDOFF_KEY = 'octopus-crawler-data'

export const readHandoff = (): ImportSitemapData | null => {
  const raw = localStorage.getItem(CRAWLER_HANDOFF_KEY)

  if (!raw) {
    return null
  }

  try {
    return JSON.parse(raw) as ImportSitemapData
  } catch {
    return null
  }
}

// A generator old enough to predate `siteUrl` still hands over its pages, and
// the first one crawled is the site's entry point.
export const siteUrlOf = (crawl: ImportSitemapData): string | null => {
  if (crawl.siteUrl) {
    return crawl.siteUrl
  }

  const first = crawl.data?.[0]?.url

  try {
    return first ? new URL(first).origin : null
  } catch {
    return null
  }
}
